import axios from 'axios'
const instance = axios.create({
    baseURL: "https://server-g8hbgn0bs-ladeadev.vercel.app/",
    headers: {
        password: "@uj09nd&@yn0SA*U(DN@)ASSDjbkjBADI@GshaBDSAHDbDfa6sdFA*"
    }
})

export default instance